import React from "react";

import { SearchListLocalization, SearchResultType } from "../types";
import { ListItem } from ".";

interface Props {
  items: SearchResultType[];
  pagination: Pagination;
  title: string;
  apiLocalization: SearchListLocalization;
  showBreadcrumbs: boolean;
}

const ItemsList: React.FC<Props> = ({ items, title, apiLocalization, showBreadcrumbs }) => {
  return (
    <>
      <div className="mb-6 text-base">
        {/* eslint-disable-next-line react/no-danger */}
        <span dangerouslySetInnerHTML={{ __html: title }} />
      </div>
      <ul className="mb-8 pl-0 last:mb-0">
        {items.map((item) => (
          <ListItem key={item.id} apiLocalization={apiLocalization} showBreadcrumbs={showBreadcrumbs} {...item} />
        ))}
      </ul>
    </>
  );
};

export default ItemsList;
